<template>
  <section  v-if="show">
    <div class="button-group">
      <ul
        class="setting-menu">
        <section
          v-for="(item,index) in list"
          :key="index">
          <li
            v-if="item.title"
            class="gray-title">
            <span>{{item.title}}</span>
          </li>
          <template v-if="item.list">
            <li
              v-for="(content,index) in item.list"
              :key="'content'+index"
              class="select-hover"
              @click="handleSelect(content)"
            >
              <span class="fs-14">
                {{content.name}}
              </span>
            </li>
          </template>
          <template v-else>
            <li
              class="select-hover"
              @click="handleSelect(item)"
            >
              <span class="fs-14">
                {{item.name}}
              </span>
            </li>
          </template>
        </section>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'selectGroupList',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: ()=>([])
    },
    selectId: {
      type: [Number,String],
      default: ''
    },
    isIcon:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      show:false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val){
        this.show = val
      }
    },
  },
  methods:{
    handleSelect(item){
      this.$emit('select',item)
    }
  }
}
</script>

<style scoped lang="scss">
.setting-menu{
  list-style: none;
  background: #FFFFFF;
  padding: 8px;
  border-radius: 6px;
  z-index: 100;
  margin-top: 10px!important;
  position: absolute;
  //box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);
  box-shadow: 0px 8px 24px rgba(66, 74, 83, 0.12), 0px 1px 3px rgba(27, 31, 36, 0.12);
  li{
    min-width: 152px;
    max-width: 256px;
    height: 33px;
    background: #FFFFFF;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #24292E!important;
    //box-shadow: inset 0px -1px 0px #E1E4E8;
    cursor: pointer;
    &.gray-title{
      color: #959DA5!important;
    }
    .fs-14{
      font-size: 14px;
    }
    span{
      margin-left: 10px;
    }
    &:last-child{
      box-shadow: none!important;
    }
    &.select-hover:hover{
      background: #f0f0f0;
      border-radius: 8px;
      font-weight: 500;
    }
  }

  //.select-hover:active{
  //  background: #000!important;
  //}

}
</style>
